import React, { FunctionComponent } from 'react'
import Modal from '../../../../../../shared/components/Modal'
import { Container, ContainerContent } from '../ModalErro/styles'
import { Grid, Button } from '@material-ui/core'
import iconeSucesso from '../../../../../../shared/assets/icons/icon-concluido-green.svg'
import { Subtitle, Title } from './styles'
import { usePagamentoBoleto } from '../../../../hooks/usePagamentoBoleto'
import { colors } from '../../../../../../shared/styles/colors'

interface ModalSucessoProp {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  imprimirComprovante: () => void
}
const ModalSucesso: FunctionComponent<ModalSucessoProp> = ({
  openModal,
  setOpenModal,
  imprimirComprovante,
}) => {
  const { limpar } = usePagamentoBoleto()
  return (
    <>
      <Modal
        openModal={openModal}
        showCloseButton
        curvature
        onCloseModal={() => setOpenModal(false)}
      >
        <Container>
          <ContainerContent>
            <Grid
              container
              spacing={0}
              justifyContent={'center'}
              alignContent={'center'}
              alignItems={'center'}
            >
              <Grid item xs={12}>
                <img src={iconeSucesso} alt="Sucesso" />
              </Grid>
              <Grid item xs={12}>
                <Title>Pagamento</Title>
              </Grid>
              <Grid
                item
                xs={12}
                justifyContent={'center'}
                alignContent={'center'}
                alignItems={'center'}
                style={{
                  textAlign: 'center',
                  marginTop: 8,
                }}
              >
                <Subtitle>
                  O pagamento do boleto foi realizado com sucesso.
                </Subtitle>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: 80,
                }}
              >
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <Button
                      variant={'outlined'}
                      style={{
                        backgroundColor: colors.white,
                        width: '100%',
                        fontWeight: 600,
                        fontSize: 14,
                        textTransform: 'capitalize',
                        color: colors.green,
                        borderColor: colors.green,
                      }}
                      onClick={() => {
                        setOpenModal(false)
                        imprimirComprovante()
                      }}
                    >
                      Ver comprovante
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      style={{
                        backgroundColor: '#24A95D',
                        width: '100%',
                        fontWeight: 600,
                        fontSize: 14,
                        textTransform: 'capitalize',
                        color: colors.white,
                      }}
                      onClick={() => {
                        setOpenModal(false)
                        limpar()
                      }}
                    >
                      Novo pagamento
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ContainerContent>
        </Container>
      </Modal>
    </>
  )
}

export default ModalSucesso
